export function youtubeUrlToId(url: string): string | null {
  const regExp = new RegExp(
    /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/,
  );
  const match = regExp.exec(url);

  return match && match[1].length == 11 ? match[1] : null;
}

export function isUrl(input: string): boolean {
  const regExp = new RegExp(
    "(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]" +
      ".[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+" +
      ".[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})",
  );

  return regExp.test(input);
}
